import { Text, TextContainer } from './star.style';

export interface StarSectionProps {
  headline: string;
}

const StarSection = ({ headline }: StarSectionProps) => {
  return (
    <TextContainer>
      <Text as="h2">{headline}</Text>
    </TextContainer>
  );
};

export default StarSection;
